__turbopack_context__.v({
  "cardGroupWrapper": "newsroomcardgroup-module-scss-module__FBFyHG__cardGroupWrapper",
  "cardStyling": "newsroomcardgroup-module-scss-module__FBFyHG__cardStyling",
  "headlineStyles": "newsroomcardgroup-module-scss-module__FBFyHG__headlineStyles",
  "linkWrapper": "newsroomcardgroup-module-scss-module__FBFyHG__linkWrapper",
  "textLinkStyles": "newsroomcardgroup-module-scss-module__FBFyHG__textLinkStyles",
  "titleStyles": "newsroomcardgroup-module-scss-module__FBFyHG__titleStyles",
});
